

import UpDownArrows from './UpDownArrows'
const TotalAgentsActive = ({activeAgentsCount}) => {
    return (
        <div className="quickStats-block">
            <div >
                <h3>{ activeAgentsCount }</h3>
                <UpDownArrows />
            </div>
            <h5>Total Active<br />Agents</h5>
        </div>
    )
}

export default TotalAgentsActive

